// src/app/services/title.service.ts
import { Injectable } from '@angular/core';
import { BrandingService } from './branding.service';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  constructor(
    private titleService: Title,
    private brandingService: BrandingService) {}

  setTitleBasedOnBrand() {
    this.titleService.setTitle(this.brandingService.title);
  }
}
